// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { useEffect, useState } from "react";

import type { GuardrailType } from "../websockets/eventTypes";
import type { SocketConnection } from "../websockets/socket";

export { type GuardrailType };

export const CHAR_LIMIT = 2500;

export const exceedsCharLimit = (text: string): boolean =>
  text.length > CHAR_LIMIT;

export function useGuardrails(socket: SocketConnection) {
  const [activeGuardrails, setActiveGuardrails] = useState<GuardrailType[]>([]);

  useEffect(() => {
    socket.on("guardrailTriggered", ({ guardrails }) => {
      setActiveGuardrails(guardrails);
    });

    return () => {
      socket.off("guardrailTriggered");
    };
  }, [socket]);

  return { activeGuardrails, setActiveGuardrails, exceedsCharLimit };
}
